export interface TierTheme {
  name: string;
  tierLevel: number;
  primary: string;
  primaryLight: string;
  primaryDark: string;
  /** Background for reward icons (Silver #E8E8E8, Gold #FBF0D0, Platinum #D8E0E8) */
  rewardBackground: string;
  /** Background for Earn/Redeem button (Silver #B8B8B8, Gold #DFBA2A, Platinum #7E93A6) */
  earnRedeemButtonBg: string;
}

export enum TierLevel {
  TIER_1 = 1,
  TIER_2 = 2,
  TIER_3 = 3
}

/* Theme colors aligned with TierService.tiersColors: Silver #A9A9A9, Gold #D2AD16, Platinum #6E8396 */
export const TIER_THEMES: Record<number, TierTheme> = {
  [TierLevel.TIER_1]: {
    name: 'Silver Tier',
    tierLevel: 1,
    primary: '#A9A9A9',
    primaryLight: '#C4C4C4',
    primaryDark: '#8A8A8A',
    rewardBackground: '#E8E8E8',
    earnRedeemButtonBg: '#B8B8B8'
  },
  [TierLevel.TIER_2]: {
    name: 'Gold Tier',
    tierLevel: 2,
    primary: '#D2AD16',
    primaryLight: '#E0C44A',
    primaryDark: '#A68B12',
    rewardBackground: '#FBF0D0',
    earnRedeemButtonBg: '#DFBA2A'
  },
  [TierLevel.TIER_3]: {
    name: 'Platinum Tier',
    tierLevel: 3,
    primary: '#6E8396',
    primaryLight: '#8A9BAB',
    primaryDark: '#556A7D',
    rewardBackground: '#D8E0E8',
    earnRedeemButtonBg: '#7E93A6'
  }
};
/** Reward icon background colors per tier (lighter than main tier colors) */
export const REWARD_ICON_COLORS: Record<string, string> = {
  SILVER: '#E8E8E8',
  GOLD: '#FBF0D0',
  PLATINUM: '#D8E0E8'
};
